import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PdfPreviewProvider } from './context/PdfPreviewContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Items from './pages/Items';
import Customers from './pages/Customers';
import Pallets from './pages/Pallets';
import Shipments from './pages/Shipments';
import Wheels from './pages/Wheels';
import Inventory from './pages/Inventory';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import PrintLabels from './pages/PrintLabels';
import QuickBooks from './pages/QuickBooks';
import NotFound from './pages/NotFound';
// Shared CSS - loaded globally (variables, common, forms, buttons, modals, tables)
import './styles/variables.css';
import './styles/common.css';
import './styles/forms.css';
import './styles/buttons.css';
import './styles/modals.css';
import './styles/tables.css';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <PdfPreviewProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/items"
            element={
              <ProtectedRoute>
                <Layout>
                  <Items />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/pallets"
            element={
              <ProtectedRoute>
                <Layout>
                  <Pallets />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/shipments"
            element={
              <ProtectedRoute>
                <Layout>
                  <Shipments />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/wheels"
            element={
              <ProtectedRoute>
                <Layout>
                  <Wheels />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Layout>
                  <Inventory />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <Reports />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <Layout>
                  <Customers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/print-labels"
            element={
              <ProtectedRoute>
                <Layout>
                  <PrintLabels />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/quickbooks"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuickBooks />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </PdfPreviewProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
